import { FeatureKey } from 'common/constants/permission'
import { PondTab } from 'modules/pond/constants'
import { PATH_DASHBOARD } from 'routes/paths'

export const getPondTabPath = (tab: PondTab, farmId: string, pondId: string): string => {
  switch (tab) {
    case PondTab.Food:
      return PATH_DASHBOARD.ponds.food(farmId, pondId)
    case PondTab.Growth:
      return PATH_DASHBOARD.ponds.growth(farmId, pondId)
    case PondTab.Water:
      return PATH_DASHBOARD.ponds.water(farmId, pondId)
    case PondTab.DeadShrimp:
      return PATH_DASHBOARD.ponds.deadShrimp(farmId, pondId)
    case PondTab.Medicine:
      return PATH_DASHBOARD.ponds.medicine(farmId, pondId)
    case PondTab.Cost:
      return PATH_DASHBOARD.ponds.cost(farmId, pondId)
    case PondTab.Sales:
      return PATH_DASHBOARD.ponds.sales(farmId, pondId)
    case PondTab.Transfer:
      return PATH_DASHBOARD.ponds.transfer(farmId, pondId)
    case PondTab.Topup:
      return PATH_DASHBOARD.ponds.topup(farmId, pondId)
    case PondTab.Setting:
      return PATH_DASHBOARD.ponds.setting(farmId, pondId)
    case PondTab.Dashboard:
    default:
      return PATH_DASHBOARD.ponds.dashboard(farmId, pondId)
  }
}

export const convertFeatureKeyToPondTab = (key: FeatureKey): PondTab => {
  switch (key) {
    case FeatureKey.Food:
      return PondTab.Food
    case FeatureKey.Growth:
      return PondTab.Growth
    case FeatureKey.WaterQuality:
    case FeatureKey.WaterMineral:
    case FeatureKey.WaterVibrio:
      return PondTab.Water
    case FeatureKey.Death:
      return PondTab.DeadShrimp
    case FeatureKey.Medicine:
      return PondTab.Medicine
    case FeatureKey.Cost:
      return PondTab.Cost
    case FeatureKey.Sales:
      return PondTab.Sales
    case FeatureKey.ShrimpTransfer:
      return PondTab.Transfer
    case FeatureKey.ShrimpTopup:
      return PondTab.Topup
    case FeatureKey.Cycle:
      return PondTab.Setting
    case FeatureKey.Dashboard:
    default:
      return PondTab.Dashboard
  }
}
